import {
  DishFirstShefCard,
  IDishFirstShefCardProps,
} from 'src/shared/design-system/DishFirstShefCard/DishFirstShefCard';
import { DishFirstShefCardLandscape } from 'src/shared/design-system/DishFirstShefCard/DishFirstShefCardLandscape';
import styled from 'styled-components';
import { match, P } from 'ts-pattern';
import { Spacing } from 'web-common/src/shared/styles';

const withMaxHeight = '320px';
const withAlternativeAvailabilityHeight = '300px';
const withDishCountHeight = '280px';
const noDishCountHeight = '263px';

export const ShefCard = styled(DishFirstShefCard)<IDishFirstShefCardProps>`
  height: ${({ nextDeliveryDate, showDishCount, showDeliveryPrice }) => {
    const showPriceOrDishCountRow = showDishCount || showDeliveryPrice;

    return match({ nextDeliveryDate, showPriceOrDishCountRow })
      .with({ nextDeliveryDate: P.not(P.nullish), showPriceOrDishCountRow: true }, () => withMaxHeight)
      .with({ nextDeliveryDate: P.not(P.nullish) }, () => withAlternativeAvailabilityHeight)
      .with({ showPriceOrDishCountRow: true }, () => withDishCountHeight)

      .otherwise(() => noDishCountHeight);
  }};
`;

export const ShefCardLandscape = styled(DishFirstShefCardLandscape)``;

export const ShefCardHalfLandscape = styled(DishFirstShefCardLandscape)`
  width: calc(50% - (${Spacing.SINGLE_HALF} / 2));
`;
